var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M3.35 6h-.7c-.358 0-.65.356-.65.79v6.42c0 .434.292.79.65.79h.7c.358 0 .65-.356.65-.79V6.79C4 6.356 3.708 6 3.35 6zm9.415-.213h-2.3c-.792 0-1.09-.32-1.118-1.164 0-.035 0-.076.005-.11l.33-2.75a.776.776 0 0 0-.01-.253C9.55.93 8.433.805 8.05 1.368c-.014.025-.034.044-.048.07l-2.82 4.44a.893.893 0 0 0-.09.178c-.05.162-.08.335-.08.508v5.872C5.01 13.3 5.655 14 6.446 14h5.193c.974 0 1.807-1.22 1.965-2.27l.564-4.135c.15-.945-.522-1.808-1.402-1.808z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.cb16450b1730d0d5234b962fd3e24ecb.svg";
export { ForwardRef as ReactComponent };